import React from "react"
import SampleCard from "./SampleCard"
import ThemeProviderWrapper from "./ThemeProviderWrapper"
import sampleStore from "../stores/sampleStore"
import Sample from "../models/sample"
import { Button, Switch, Grid2 } from "@mui/material"
import { observer, Provider } from "mobx-react"
import { styled } from "@mui/material/styles"
import { triggerSamplesPlayback } from "../utils/userUtils"

const stores = {
  sampleStore,
}

const PlaybackButton = styled(Button)`
  width: 100%;
  background-color: ${(props) => props.samplesArePlaying ? '#ee534f' : ''};
  &:hover {
    background-color: ${(props) => props.samplesArePlaying ? '#f38784' : ''};
  }
`

const PlaybackIcon = styled('i')`
  margin-right: 10px;
`

const SampleCardContainer = styled(Grid2)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

@observer
export default class ComplementarySamples extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      samplesArePlaying: false,
    }
    sampleStore.samples = props.samples.map(
      (sample) => new Sample(sample)
    )
    this.sampleCardRefs = props.samples.map((sample) => React.createRef())
    sampleStore.canPlayMultipleSamplesAtOnce = true
  }

  checkIfSamplesArePlaying = () => {
    const anySamplePlaying = this.sampleCardRefs.some(
      (sampleCardRef) => sampleCardRef.current.props.sample.isPlaying
    )
    this.setState({ samplesArePlaying: anySamplePlaying })
  }

  handlePlayInSyncClick = () => {
    const anySamplePlaying = this.sampleCardRefs.some(
      (sampleCardRef) => sampleCardRef.current.props.sample.isPlaying
    )

    this.sampleCardRefs.forEach((sampleCardRef) => {
      if (anySamplePlaying) {
        sampleCardRef.current.handleStopSound()
      } else {
        sampleCardRef.current.handlePlaySoundOnce()
      }
    })

    triggerSamplesPlayback(!anySamplePlaying)

    this.checkIfSamplesArePlaying()
  }

  handleSwitchChange = (sample) => {
    sample.toggleEnabledForPlay()
  }

  renderSampleRow(samples) {
    const sampleSlugs = samples.map((sample) => sample.slug)
    return (
      <Grid2 container spacing={2} key={sampleSlugs}>
        {samples.map((sample, idx) => {
          return (
            <SampleCardContainer item size={{ xs: 12, sm: 6, md: 3}} key={sample.slug}>
              <Switch
                checked={sample.enabledForPlay}
                onChange={() => this.handleSwitchChange(sample)}
              />
              <SampleCard
                sample={sample}
                ref={this.sampleCardRefs[idx]}
              />
            </SampleCardContainer>
          )
        })}
      </Grid2>
    )
  }

  render() {
    const { samplesArePlaying } = this.state
    const samples = sampleStore.samples
    const samplesCount = samples.length
    const rows = []
    let currentRow = []

    samples.forEach((sample, idx) => {
      currentRow.push(sample)
      if (currentRow.length === 4 || samplesCount - 1 === idx) {
        rows.push(currentRow)
        currentRow = []
      }
    })

    const rowsToRender = rows.map((row) => {
      return this.renderSampleRow(row)
    })

    return (
      <Provider {...stores}>
        <ThemeProviderWrapper>
          <div id="samples">
            <Grid2 container spacing={3}>
              <Grid2 item size={12}>
                <PlaybackButton
                  color="primary"
                  size="large"
                  onClick={this.handlePlayInSyncClick}
                  variant="contained"
                  disableElevation
                  samplesArePlaying={samplesArePlaying}
                >
                  <PlaybackIcon className={samplesArePlaying ? "fas fa-stop" : "fas fa-play"} />
                  {samplesArePlaying ? "Stop playing" : "Play selected in sync"}
                </PlaybackButton>
              </Grid2>
            </Grid2>

            {rowsToRender}
          </div>
        </ThemeProviderWrapper>
      </Provider>
    )
  }
}
